export function getCloseReviewSubmissionPageLink(productId: string | null, variationId: string | null, referrer: string | null): string {
    if (referrer && !isReferrerLoginPage(referrer) && isReferrerOnOtto(referrer)) {
        return createReferrerLink(referrer, variationId);
    }

    if (productId) {
        return createReferrerLink(`/p/${productId}/`, variationId);
    }

    return '/';
}

function isReferrerLoginPage(referrer: string) {
    return referrer.includes('customer-identity/login');
}

function isReferrerOnOtto(referrer: string) {
    try {
        const url = new URL(referrer);
        return url.host.includes('otto.de');
    } catch {
        return false;
    }
}

function createReferrerLink(referrer: string, variationId: string | null) {
    if (isPDP(referrer) && variationId) {
        try {
            const url = new URL(referrer, window.location.origin);
            url.searchParams.set('variationId', variationId);
            return url.toString();
        } catch {
            /*                                                 */
            return referrer;
        }
    }

    return referrer;
}

function isPDP(referrer: string) {
    return referrer.includes('/p/') || referrer.includes('/dcs/products');
}
